import React from "react"
import ReactDOM from "react-dom"
import MerchantPage from "./merchant-page"

export default class MerchantPageModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.currentPageJson = elem.dataset.currentPageJson && JSON.parse(elem.dataset.currentPageJson)
    self.merchantPageLabels = elem.dataset.merchantPageLabels && JSON.parse(elem.dataset.merchantPageLabels)
    self.categoriesText = elem.dataset.categoriesText && JSON.parse(elem.dataset.categoriesText)
    self.weekdays = elem.dataset.weekdays && JSON.parse(elem.dataset.weekdays)
    self.openingHours = elem.dataset.openinghours && JSON.parse(elem.dataset.openinghours)
    self.otherStores = elem.dataset.otherStores && JSON.parse(elem.dataset.otherStores)
    self.similarStores = elem.dataset.similarStores && JSON.parse(elem.dataset.similarStores)
    self.clickAndCollectWebSiteAddress = elem.dataset.clickAndCollectWebSiteAddress
    self.linkTargetSettings = elem.dataset.linkTargetSettings
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(
      <MerchantPage
        {...self.currentPageJson}
        merchantPageLabels={self.merchantPageLabels}
        categoriesText={self.categoriesText}
        lang={document.body && document.body.dataset.language}
        openingHours={self.openingHours}
        weekdays={self.weekdays}
        otherStores={self.otherStores}
        similarStores={self.similarStores}
        clickAndCollectWebSiteAddress={self.clickAndCollectWebSiteAddress}
        linkTargetSettings={self.linkTargetSettings}
      />,
      self.elem,
    )
  }
}
